// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import SellingCostsInput from '../selling-costs';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.SELLING_COSTS,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.HOME_CLOSING_COST_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    //   additional_attributes: {
    //     closing_cost_type: 'selling',
    //   },
    // },
  },
};
const SellingCostsInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <SellingCostsInput
      label={label}
      tooltip={tooltip}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default SellingCostsInputWithAnalytics;
